export const SliderData=[
    {
        img:'https://images-eu.ssl-images-amazon.com/images/G/31/img23/Softlines_JWL_SH_GW_Assets/UNREC/8th/v1/3000_unrec._CB596352848_.jpg'
    },
    {
        img:'https://images-eu.ssl-images-amazon.com/images/G/31/img20/HSS/sep23/3000-x-1200-UNREC_2._CB595936287_.jpg'
    },
    {
        img:'https://images-eu.ssl-images-amazon.com/images/G/31/img22/Toys/GW/GW-Hero-PC_BBAug23_Soft-toys_with-Apay_Lifestyle_2x._CB597740150_.jpg'
    },
    {
        img:'https://images-eu.ssl-images-amazon.com/images/G/31/img21/Wireless/Shreyansh/BAU/Unrexc/D70978891_INWLD_BAU_Unrec_Uber_PC_Hero_3000x1200._CB594707876_.jpg'
    },
    {
        img:'https://images-eu.ssl-images-amazon.com/images/G/31/img23/Beauty/GW/Skincare-PCaa._CB595887158_.jpg'
    }
]